import { render, staticRenderFns } from "./FormGraduated.vue?vue&type=template&id=27f2fbae&scoped=true&"
var script = {}
import style0 from "./FormGraduated.vue?vue&type=style&index=0&id=27f2fbae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f2fbae",
  null
  
)

export default component.exports